import { ReactComponent as Logo } from "../../shared/logo.svg";
import { ReactComponent as Burger } from "../../shared/burger.svg";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import DimensionsContext from "../../../context/dimensions/dimensions";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import SideBar from "../SideBar/SideBar";

export default function Header() {
  const { t, i18n } = useTranslation();
  const { x } = useContext(DimensionsContext);
  const navigate = useNavigate();

  const [openSideBar, setOpenSideBar] = useState(false);

  useEffect(() => {
    if (x > 800) setOpenSideBar(false);
  }, [x]);

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="header">
      {x > 800 ? (
        <>
          <div className="header-side">
            <Link aria-label="Logo" to="/">
              <Logo />
            </Link>
            <button
              onClick={() => {
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("home")?.scrollIntoView();
              }}
              className="header-link"
            >
              {t("header_home")}
            </button>
            <button
              onClick={() => {
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("products")?.scrollIntoView();
              }}
              className="header-link"
            >
              {t("header_products")}
            </button>
            <button
              onClick={() => {
                if (window.location.pathname !== "/") {
                  navigate("/");
                }
                document.getElementById("contacts")?.scrollIntoView();
              }}
              className="header-link"
            >
              {t("header_contact")}
            </button>
          </div>
          <div className="header-side">
            <label className="header-link">{t("header_language")}</label>
            <select
              className="select"
              name="selectedFilter"
              onChange={(e) => changeLanguageHandler(e.target.value)}
              defaultValue={i18n.language}
            >
              <option className="header-link option" value="en">
                English
              </option>
              <option className="header-link" value="ru">
                Русский
              </option>
              <option className="header-link" value="es">
                Español
              </option>
              <option className="header-link" value="pt">
                Português
              </option>
            </select>
          </div>
        </>
      ) : (
        <>
          <Link to="/">
            <Logo />
          </Link>
          <div className="header-side">
            <button
              onClick={() => document.getElementById("contacts")?.scrollIntoView()}
              className="demo-button"
            >
              <p>{t("contact_button")}</p>
            </button>
            <button
              aria-label="Open Sidebar"
              onClick={() => setOpenSideBar(true)}
            >
              <Burger />
            </button>
          </div>
        </>
      )}
      <SideBar open={openSideBar} onClose={() => setOpenSideBar(false)} />
    </div>
  );
}
